import { USER_SIGNIN, USER_INFO, USER_SIGNOUT, USER_EDIT } from '../types'
import userimg from '@/assets/images/icon-user.png'
import { setStorage, getStorage, removeStorage } from '@/hiti/Storage.js'
export default {
  state: {
    user: getStorage('user', {}),
    userInfo: getStorage('userInfo', {}),
  },
  getters: {
    userImg: (state) => {
      return state.user.userUrl
    },
    user: (state) => {
      return state.user
    },
    islogin: (state) => {
      return !!state.user.access_token
    },
    funCode: (state) => {
      return state.user.funcCode
    },
    userInfo: (state) => {
      return state.userInfo
    },
  },
  mutations: {
    [USER_SIGNIN](state, user) {
      setStorage('user', user)
      setStorage('ACCESS-TOKEN', user.access_token)
      state.user = user
    },
    [USER_INFO](state, userInfo) {
      setStorage('userInfo', userInfo)
      state.userInfo = userInfo
    },
    [USER_SIGNOUT](state) {
      removeStorage('user')
      removeStorage('ACCESS-TOKEN')
      state.user = {}
    },
    [USER_EDIT](state, user) {
      user = Object.assign(state.user, user)
      setStorage('user', user)
      state.user = user
    },
  },
  actions: {
    [USER_SIGNIN]({ commit }, user) {
      if (!user.userUrl) {
        user.userUrl = userimg
      }
      // console.log(user);
      commit(USER_SIGNIN, user)
    },
    [USER_INFO]({ commit }, userInfo) {
      // if (!user.userUrl) {
      //   user.userUrl = userimg
      // }
      commit(USER_INFO, userInfo)
    },
    [USER_SIGNOUT]({ commit }) {
      commit(USER_SIGNOUT)
    },
    [USER_EDIT]({ commit }, user) {
      commit(USER_EDIT, user)
    },
  },
}
